const createMentorship = async (mentorship) => {

    const response = await fetch(`/api/public/mentorships/create`, {
        method: 'POST',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(mentorship)
    });
    
    if(!response.ok){
        throw await response.json();
    }

    return response;
}

export {
    createMentorship
}
